import { IBodyGoldPrice, ITemplateChart } from 'api/types/_campaign';
import { Option } from 'api/types/_public';
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import LabelWrapper from 'components/Common/LabelWrapper';
import ModalConfirm from 'components/Common/ModalConfirm';
import TooltipCustom from 'components/Common/TooltipCustom';
import { useRole } from 'components/Hooks/UserHooks';
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { CATEGORY_TEMPLATE_VOTE_KEYWORD_OPTIONS, STATUS_CAMPAIGN_OPTIONS, TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT, TEMPLATE_ELEMENT_TYPE_BOOSTING_CONTENT } from 'helpers/constans';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from 'react-countup';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CardBody, CardHeader, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import { createSelector } from "reselect";
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import TableContainer from "../../../components/Common/TableContainer";
import { allTemplateChart, allVariablesTemplateVote, deleteSubjectVote, getBodyVotes as onGetBodyVotes } from "../../../store/thunks";
import BodyForm from './BodyForm';
import DropdownOption from 'components/Common/DropdownOption';
export interface Tag {
    id: string;
    text: string;
}

const TYPE_SELECT_DEFAULT: string = 'id';

registerLocale('en', en);
registerLocale('ko', ko);

const BodyList = (activeTab?: any) => {
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();

    const STATUS_CAMPAIGN_OPTIONS_LANG: any = STATUS_CAMPAIGN_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const CATEGORY_TEMPLATE_VOTE_KEYWORD_OPTIONS_LANG = CATEGORY_TEMPLATE_VOTE_KEYWORD_OPTIONS?.map((item: any) => ({ value: `${item?.value}`, label: t(item?.label) }));

    const [query, setQuery]: any = useQueryParams({
        time_request: withDefault(NumberParam, 0),
        page: withDefault(NumberParam, 1),
        limit: withDefault(NumberParam, 30),
        sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
        order_by: withDefault(StringParam, 'DESC'),
        name: withDefault(StringParam, ''),
        categories: withDefault(StringParam, `${TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.ONGOING_VOTE_KEYWORD},${TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.COMPLETED_VOTE_KEYWORD}`),
        element_type: withDefault(StringParam, `${TEMPLATE_ELEMENT_TYPE_BOOSTING_CONTENT.BODY}`),
        // start_date: withDefault(StringParam, START_DATE),
        // end_date: withDefault(StringParam, END_DATE),
        // is_active: withDefault(StringParam, ''),

    });

    const [nameSearch, setNameSearch] = useState<string>(query?.name || "");

    const [statusSearch, setStatusSearch] = useState<Option | null>(STATUS_CAMPAIGN_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(query?.is_active)) || null);

    const [typeSearch, setTypeSearch] = useState<Option | null>(CATEGORY_TEMPLATE_VOTE_KEYWORD_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(query?.categories)) || { label: t('All'), value: `${TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.ONGOING_VOTE_KEYWORD},${TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.COMPLETED_VOTE_KEYWORD}` });

    const [dateSearch, setDateSearch] = useState<any[]>([query?.start_date ? moment(query?.start_date, 'Y-MM-DD').toDate() : null, query?.end_date ? moment(query?.end_date || '', 'Y-MM-DD').toDate() : null]);
    const [startDate, endDate] = dateSearch;

    const [bodyDetail, setBodyDetail] = useState<IBodyGoldPrice | null>(null);

    const [idLoading, setIdLoading] = useState<string | number | null>(null);

    const [isShowTemplate, setIsShowTemplate] = useState<boolean>(false);
    const [templateShow, setTemplateShow] = useState<string>('');

    const [templateChart, setTemplateChart] = useState<ITemplateChart[]>([]);

    const [variablesTemplateVote, setVariablesTemplateVote] = useState<any[]>([]);

    const [linkImage, setLinkImage] = useState<string>('');

    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => state.Campaign;

    const CampaignProperties = createSelector(
        selectLayoutState,
        (state) => ({
            bodyVotes: state.bodyVotes,
            isBodyVoteSuccess: state.isBodyVoteSuccess,
            isBodyVoteLoading: state.isBodyVoteLoading,
            error: state.error,
        })
    );

    // Inside your component
    const { bodyVotes, error, isBodyVoteLoading } = useSelector(CampaignProperties);

    useEffect(() => {
        dispatch(onGetBodyVotes(query));
    }, [JSON.stringify(query)]);

    const searchData = () => {
        const queryNew = {
            ...query,
            name: nameSearch || '',
            categories: typeSearch?.value || `${TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.ONGOING_VOTE_KEYWORD},${TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.COMPLETED_VOTE_KEYWORD}`,
            start_date: startDate ? moment(new Date(startDate)).format("Y-MM-DD") : '',
            end_date: endDate ? moment(new Date(endDate)).format("Y-MM-DD") : '',
            is_active: `${statusSearch?.value}`,
            page: 1,
            time_request: + new Date()
        };
        setQuery(queryNew);
    };

    const resetData = () => {
        const queryNew = {
            ...query,
            name: '',
            categories: `${TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.ONGOING_VOTE_KEYWORD},${TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.COMPLETED_VOTE_KEYWORD}`,
            is_active: '',
            start_date: '',
            end_date: '',
            order_by: 'DESC',
            sort_by: TYPE_SELECT_DEFAULT,
            time_request: + new Date(),
            page: 1,
        };
        setQuery(queryNew, "push");
        setNameSearch((_prev) => '');
        setStatusSearch(null);
        setTypeSearch({ label: t('All'), value: `${TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.ONGOING_VOTE_KEYWORD},${TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.COMPLETED_VOTE_KEYWORD}` });
        setDateSearch([queryNew?.start_date ? moment(queryNew?.start_date || "", 'Y-MM-DD').toDate() : null, queryNew?.end_date ? moment(queryNew?.end_date || "", 'Y-MM-DD').toDate() : null]);
    };

    const triggerRefresh = async (type: string = '') => {
        onCloseClick();
        setQuery({
            ...query,
            time_request: + new Date(),
        }, "push");
    }
    //End::Update

    const handleSetBodyDetail = (detail: IBodyGoldPrice | null) => {
        setBodyDetail((_prev) => detail);
    }

    const onCloseClick = () => {
        handleSetBodyDetail(null);
    }

    const handleShowTemplate = (_prompt: string = '') => {
        setTemplateShow((_prev) => _prompt);
        setIsShowTemplate((_prev) => true);
    }

    // Begin::Delete

    const [isOpenConfirm, setIsConfirm] = useState<boolean>(false);
    const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
    const [initialValuesDefault, setInitialValuesDefault] = useState<IBodyGoldPrice | null>(null);

    const handleConfirmDelete = (item: IBodyGoldPrice) => {
        setInitialValuesDefault((_prev) => item);
        setIsConfirm((_prev) => true);
    };

    const handleActionDelete = async () => {
        if (!(initialValuesDefault?.id)) { return; };
        try {
            setIsConfirmLoading((_prev) => true);
            const response: any = await deleteSubjectVote(initialValuesDefault?.id);
            if (response?.code === 200) {
                dispatch(onGetBodyVotes(query));
                setIsConfirmLoading((_prev) => false);
                setIsConfirm((_prev) => false);
                setInitialValuesDefault((_prev) => null);
                toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
            } else {
                setIsConfirmLoading((_prev) => false);
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsConfirmLoading((_prev) => false);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const onCloseConfirmClick = () => {
        setInitialValuesDefault((_prev) => null);
        setIsConfirm((_prev) => false);
    }
    // End::Delete

    // Column
    const columns = useMemo(
        () => [
            {
                Header: t('ID'),
                accessor: "id",
                filterable: true,
                sortable: true,
                width: 60,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => (
                    <>
                        <div style={{ minWidth: '40px' }}>{cell?.value}</div>
                    </>
                ),
            },
            // {
            //     Header: t('Active Action'),
            //     accessor: "is_active",
            //     filterable: false,
            //     sortable: false,
            //     thClass: 'text-center align-middle',
            //     width: 100,
            //     Cell: (cell: any) => {
            //         const item: any = cell?.row?.original;
            //         const active = item?.is_active;
            //         return (
            //             <div className="text-center form-check form-switch form-switch-sm position-relative" dir="ltr" style={{ minWidth: '80px' }}>
            //                 {(String(idLoading) === String(item?.id)) && <span className="position-absolute" style={{ top: '3px', left: 0 }}><Spinner size="sm" className="text-primary" /></span>}
            //                 <input type="checkbox" className="form-check-input" name="status" id="customSwitchsizelg" checked={Boolean(active)}
            //                     onChange={(event: any) => {
            //                         if (isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_VOTE_UPDATE, userPermissions)) {
            //                             handleUpdateCampaignCar(
            //                                 { id: item?.id, is_active: event.target.checked }
            //                             );
            //                         }
            //                     }}
            //                 />
            //             </div>
            //         );
            //     }
            // },

            {
                Header: t('Name'),
                accessor: "name",
                filterable: true,
                sortable: false,
                width: 180,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '180px' }} className="d-flex flex-wrap ">
                            {item?.name || '-'}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Type'),
                accessor: "type",
                thClass: 'text-center',
                filterable: true,
                sortable: false,
                thWidth: 150,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const _type = CATEGORY_TEMPLATE_VOTE_KEYWORD_OPTIONS_LANG?.find((_m: any) => (String(item?.category) === String(_m?.value)));
                    return (
                        <>
                            <div className="w-100 text-center " style={{ minWidth: '130px' }}>
                                {_type?.label || ''}
                            </div>
                        </>
                    )
                },
            },
            {
                Header: t('Template'),
                accessor: "content",
                filterable: true,
                sortable: false,
                width: 350,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '300px', maxWidth: '100%', whiteSpace: 'break-spaces' }} className="cursor-pointer hover-underline text-over-two-line" onClick={() => handleShowTemplate(item?.content)}>
                            {item?.content || '-'}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Info-Graphic'),
                accessor: "graphic_info",
                thClass: 'text-center',
                filterable: true,
                sortable: false,
                thWidth: 130,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const _chart = (templateChart || [])?.find((_m: any) => (String(item?.chart_code) === String(_m?.code)));
                    return (
                        <>
                            <div className="w-100 text-center " style={{ minWidth: '150px' }}>
                                <div style={{ width: '90px' }} className="m-auto cursor-pointer" onClick={() => setLinkImage((prev) => _chart?.image_url || '')}>
                                    <img src={_chart?.image_url || ''} className="flex-shrink-0 rounded w-100" alt={item?.name_korea} />
                                </div>
                            </div>
                        </>
                    )
                },
            },
            // {
            //     Header: t('Boosting Keyword'),
            //     accessor: "keyword",
            //     filterable: true,
            //     sortable: false,
            //     width: 120,
            //     thClass: 'text-start align-middle',
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         return (<>
            //             <div style={{ minWidth: '100px' }} className="d-flex flex-wrap ">
            //                 {item?.keyword || '-'}
            //             </div>
            //         </>)
            //     },
            // },
            {
                Header: t('Created At'),
                accessor: "created_at",
                filterable: true,
                sortable: true,
                thWidth: 130,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end pe-3" style={{ minWidth: '120px' }}>
                            <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
                        </div>
                    )
                },
            },
            {
                Header: t('Updated at'),
                accessor: "updated_at",
                filterable: true,
                sortable: false,
                thWidth: 150,
                thClass: 'text-end align-middle',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end" style={{ minWidth: '100px' }}>
                            <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
                        </div>
                    )
                },
            },
            {
                Header: t('Actions'),
                accessor: "__",
                thClass: 'align-middle text-center',
                thWidth: 120,
                sortable: false,
                Cell: (cell: any) => {
                    const item: any = cell?.row?.original;
                    return (
                        <ul className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0" style={{ minWidth: '90px' }}>
                            {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_VOTE_UPDATE, userPermissions) && <TooltipCustom
                                title={t('Button Update Body')}
                                id={`update-us-${item?.id}`}
                            >
                                <li className=" list-inline-item me-0" id={`update-us-${item?.id}`}>
                                    <Link className="btn btn-sm btn-soft-primary edit-item-btn" to="#"
                                        onClick={(e) => { e.preventDefault(); handleSetBodyDetail(item) }}
                                    >
                                        <i className="ri-pencil-fill align-bottom"></i>
                                    </Link>
                                </li>
                            </TooltipCustom>}
                            {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_VOTE_DELETE, userPermissions) && (
                                <TooltipCustom
                                    title={t('Button Delete Body')}
                                    id={`detail-cp-${item?.id}`}
                                >
                                    <li className="list-inline-item" id={`detail-cp-${item?.id}`}>
                                        <Link className="btn btn-sm btn-soft-danger edit-item-btn" to="#"
                                            onClick={(e) => { e.preventDefault(); handleConfirmDelete(item) }}
                                        >
                                            <i className="ri-delete-bin-3-fill align-bottom"></i>
                                        </Link>
                                    </li>
                                </TooltipCustom>
                            )}
                        </ul>
                    );
                },
            },
        ],
        [i18n?.language, idLoading, JSON.stringify(userPermissions), JSON.stringify(templateChart)]
    );

    const handleChangePage = useCallback((page: any) => {
        setQuery({ page: page + 1 })
    }, []);

    const handleChangeSorting = useCallback((sortBy: any) => {
        setQuery((_prev: any) => {
            return ({ ..._prev, ...sortBy });
        });
    }, []);

    const handleCallAllOption = async () => {
        try {
            const [res1, res2]: any = await Promise.all([allTemplateChart({}), allVariablesTemplateVote()]);
            const _list_template_chart = (res1?.data || []);
            setTemplateChart((_prev: any) => _list_template_chart);
            const _list_variable = (res2?.data || []);
            setVariablesTemplateVote((_prev: any) => _list_variable);
        } catch (error: any) {
            return error;
        }
    };

    const handleChangePicker = (values: any[] = []) => {
        setDateSearch((_prev: any) => values);
    }

    const onCloseImageClick = (e: any) => {
        setLinkImage((_prev) => '');
    };

    useEffect(() => {
        handleCallAllOption();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        document.body.classList.remove('vertical-sidebar-enable');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    return (
        <React.Fragment>
            <Row>
                {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_VOTE_LIST, userPermissions) && (
                    <Col lg={12}>
                        <div>
                            <CardHeader className="border-0">
                                <Row className="g-4 align-items-center">
                                    <div className="col-sm-7">
                                        <div>
                                            <h5 className="card-title mb-0">
                                                <span>
                                                    <span className="me-2">{t('Total')}:</span>
                                                    {(isBodyVoteLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                                        start={0}
                                                        end={bodyVotes?.pagination?.total || 0}
                                                        duration={1}
                                                        className="text-primary"
                                                    />)}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="col-sm-5 text-end">
                                        {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_VOTE_CREATE, userPermissions) && (<div className="col-sm-auto">
                                            <div>
                                                <button
                                                    type="button"
                                                    className="btn btn-success add-btn rounded-pill"
                                                    id="create-btn"
                                                    onClick={() => {
                                                        handleSetBodyDetail({ time_request: + new Date() } as any)
                                                    }}
                                                >
                                                    <i className="ri-add-line align-bottom me-1"></i>
                                                    {t('Button Create Body')}
                                                </button>
                                            </div>
                                        </div>)}
                                    </div>
                                </Row>
                            </CardHeader>
                            <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                                <Row className="g-4 align-items-center mt-0">
                                    <Col sm={6} md={6} lg={4} xl={3} xxl={3} className='mt-3'>
                                        <LabelWrapper label={t('Name')} isShow={!!nameSearch}>
                                            <Input
                                                type="text"
                                                className="form-control search"
                                                placeholder={`${t('Name')}...`}
                                                value={nameSearch}
                                                onChange={(e) => setNameSearch(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        searchData();
                                                    }
                                                }}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={6} md={6} lg={4} xl={3} xxl={3} className='mt-3'>
                                        <LabelWrapper label={t('Type')} isShow={true}>
                                            <DropdownOption
                                                name="cycle_type"
                                                dataList={CATEGORY_TEMPLATE_VOTE_KEYWORD_OPTIONS_LANG || []}
                                                placeholder={`${t("Type")}...`}
                                                className="dropdown-status-rounded z-hight"
                                                classNamePrefix="name-prefix"
                                                initialValue={typeSearch || null}
                                                onChangeSelect={(e: any) => setTypeSearch(e)}
                                                isHasOptionAll={true}
                                                optionAll={{ label: t('All'), value: `${TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.ONGOING_VOTE_KEYWORD},${TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.COMPLETED_VOTE_KEYWORD}` }}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    {/* <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='mt-3 mt-md-2'>
                                                <LabelWrapper label={t('Sub Keyword')} isShow={!!keywordSubSearch}>
                                                    <Input
                                                        type="text"
                                                        className="form-control search"
                                                        placeholder={`${t('Sub Keyword')}...`}
                                                        value={keywordSubSearch}
                                                        onChange={(e) => setKeywordSubSearch(e.target.value)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                </LabelWrapper>
                                    </Col> */}
                                    {/* <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='mt-3 mt-xxl-2'>
                                        <LabelWrapper label={t('Status')} isShow={true}>
                                            <DropdownStatus
                                                name="status"
                                                dataList={STATUS_CAMPAIGN_OPTIONS_LANG || []}
                                                placeholder={`${t("Status")}...`}
                                                className="dropdown-status-rounded z-hight"
                                                classNamePrefix="name-prefix"
                                                initialValue={statusSearch || null}
                                                onChangeSelect={(e: any) => setStatusSearch(e)}
                                                isHasOptionAll={true}
                                                optionAll={{ label: t('All'), value: '' }}
                                                colors={COLORS_STATUS_CAMPAIGN}
                                            />
                                        </LabelWrapper>
                                    </Col> */}
                                    {/* <Col sm={6} md={6} lg={6} xl={6} xxl={3} className='date-picker-wrapper-custom mt-3 mt-xxl-2'>
                                        <LabelWrapper label={t('Date')} isShow={!!startDate || !!endDate}>
                                            <DatePickerCustom
                                                placeholder={`${t('Start Date')} - ${t('End Date')}`}
                                                startDate={startDate || null}
                                                endDate={endDate || null}
                                                onChangePicker={handleChangePicker}
                                                showOptions={[
                                                    'today', 'yesterday', 'two_day_ago',
                                                    'last_3_days', 'last_7_days', 'last_14_days', 'last_30_days',
                                                    'this_week', 'last_week',
                                                    'this_month', 'last_month',
                                                ]}
                                            />
                                        </LabelWrapper>
                                    </Col> */}
                                    <Col sm={12} md={12} lg={4} xl={6} xxl={6} className="hstack gap-1 justify-content-center justify-content-sm-end justify-content-lg-start mt-3">
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-primary me-2 "
                                                onClick={searchData}
                                                disabled={isBodyVoteLoading}
                                            >
                                                <i className="ri-search-line align-bottom me-1"></i>{" "}
                                                {t('Button Search')}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary fs-14"
                                                onClick={resetData}
                                            >
                                                <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                {t('Button Reset')}
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <CardBody className="pt-3">
                                <TableContainer
                                    className="custom-header-css"
                                    divClass="table-responsive table-card"
                                    tableClass="align-middle"
                                    theadClass="table-light"
                                    columns={columns}
                                    data={bodyVotes?.list?.length ? bodyVotes?.list : []}
                                    customPageSize={query.limit}
                                    customPageIndex={query.page - 1}
                                    totalRecords={bodyVotes?.pagination?.total}
                                    customPageCount={Math.ceil(Number(bodyVotes?.pagination?.total) / Number(bodyVotes?.pagination?.limit))}
                                    handleChangePage={handleChangePage}
                                    manualSorting={true}
                                    sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                                    handleChangeSorting={handleChangeSorting}
                                    isLoading={isBodyVoteLoading}
                                    isShowHeaderTableFixedTab={activeTab}
                                />
                            </CardBody>
                        </div>
                    </Col>
                )}
            </Row>

            <BodyForm
                isOpen={!!bodyDetail}
                detail={bodyDetail}
                templateChart={templateChart}
                variables={variablesTemplateVote}
                onClose={onCloseClick}
                triggerRefresh={triggerRefresh}
            />

            <ModalConfirm
                header={t('Button Delete Body')}
                isOpen={isOpenConfirm}
                isLoading={isConfirmLoading}
                onClose={onCloseConfirmClick}
                onConfirm={handleActionDelete}
            />

            <Modal
                isOpen={!!isShowTemplate}
                centered={true}
                size="lg"
                scrollable={true}
                toggle={() => setIsShowTemplate(() => false)}
            >
                <ModalHeader toggle={() => setIsShowTemplate(() => false)}>
                    <>{t("Template")}</>
                </ModalHeader>
                <ModalBody className="pt-0">
                    <div className="fs-15" style={{ whiteSpace: 'break-spaces' }}>
                        {templateShow || ''}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div className="d-flex justify-content-center align-item-center">
                        <button
                            className="btn btn-secondary"
                            type="button"
                            onClick={() => setIsShowTemplate(() => false)}
                            style={{ width: '100px' }}
                        >
                            <i className="ri-close-fill" style={{ lineHeight: '22px' }} /> <span className="ms-1">{t("Button Close")}</span>
                        </button>
                    </div>
                </ModalFooter>
            </Modal>

            <Modal isOpen={!!linkImage} centered={true} size="lg" scrollable={true} toggle={onCloseImageClick} keyboard={true}>
                <ModalBody className="">
                    <img src={linkImage || ''} className="flex-shrink-0 rounded w-100" alt="chart" />
                </ModalBody>
            </Modal>

            <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={3000} limit={2} />
        </React.Fragment >
    );
};

export default BodyList;